<template>
    <div class="left_panel my_order">
        <div class="d-flex justify-content-between align-items-start mb_10">
            <h2 class="mb-0">My Orders</h2>
            <industry-matched-users-group :users="matchedUsers" />
        </div>
        <!-- <div class="subhead">Orders this month </div> -->
        <div class="panel_main_box">
            <div class="row new_my_order_coustome_row">
                <div
                    class="my_account_main_top_box_custom"
                    @click="onChangeStatus(null)"
                    style="cursor: pointer"
                >
                    <div
                        class="total_order_box"
                        :class="{
                            order_status_active: listConfig.order_status == null
                        }"
                    >
                        <div class="box_img">
                            <img alt="" src="/maincss/images/total_order.svg" />
                        </div>
                        <div class="box_left">
                            <div class="order-text">Total Orders</div>
                            <div class="order_box_num">
                                <h3>{{ all_order_length }}</h3>
                                <!-- <img alt="" src="/maincss/images/zigzag_arrow.svg" /> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="my_account_main_top_box_custom"
                    @click="onChangeStatus(null, 'OPEN ORDERS')"
                    style="cursor: pointer"
                >
                    <div
                        class="total_order_box"
                        :class="{
                            order_status_active:
                                listConfig.order_status == 'OPEN ORDERS'
                        }"
                    >
                        <div class="box_img">
                            <img alt="" src="/maincss/images/inprogress.svg" />
                        </div>
                        <div class="box_left">
                            <div class="order-text">Open Orders</div>
                            <div class="order_box_num">
                                <h3 v-if="'OPEN ORDERS' in status_count">
                                    {{ status_count["OPEN ORDERS"] }}
                                </h3>
                                <h3 v-else>0</h3>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="my_account_main_top_box_custom"
                    @click="onChangeStatus(null, 'INREVIEW')"
                    style="cursor: pointer"
                >
                    <div
                        class="total_order_box"
                        :class="{
                            order_status_active:
                                listConfig.order_status == 'INREVIEW'
                        }"
                    >
                        <div class="box_img">
                            <img alt="" src="/maincss/images/eye.svg" />
                        </div>
                        <div class="box_left">
                            <div class="order-text">Proof Review</div>
                            <div class="order_box_num">
                                <h3 v-if="'INREVIEW' in status_count">
                                    {{ status_count["INREVIEW"] }}
                                </h3>
                                <h3 v-else>0</h3>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="my_account_main_top_box_custom"
                    @click="onChangeStatus(null, 'BACKORDER')"
                    style="cursor: pointer"
                >
                    <div
                        class="total_order_box"
                        :class="{
                            order_status_active:
                                listConfig.order_status == 'BACKORDER'
                        }"
                    >
                        <div class="box_img">
                            <img alt="" src="/maincss/images/back_order.svg" />
                        </div>
                        <div class="box_left">
                            <div class="order-text">Back Order</div>
                            <div class="order_box_num">
                                <h3 v-if="'BACK ORDER' in status_count">
                                    {{ status_count["BACK ORDER"] }}
                                </h3>
                                <h3 v-else>0</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="table_layout my_oder" id="tabs">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-xl-5 recent_order">
                        <nav class="table_tab">
                            <div
                                class="nav nav-tabs nav-fill"
                                id="nav-tab"
                                role="tablist"
                            >
                                <a
                                    @click="changeOrders('recent')"
                                    class="nav-item nav-link"
                                    id="nav-profile-tab"
                                    data-toggle="tab"
                                    href="javascript:;"
                                    role="tab"
                                    aria-controls="nav-profile"
                                    aria-selected="false"
                                    >Recent Order</a
                                >
                                <a
                                    @click="changeOrders('all')"
                                    class="nav-item nav-link active"
                                    id="nav-contact-tab"
                                    data-toggle="tab"
                                    href="javascript:;"
                                    role="tab"
                                    aria-controls="nav-contact"
                                    aria-selected="false"
                                    >All Orders ({{ item_length }})</a
                                >
                            </div>
                        </nav>
                    </div>
                    <div class="col-lg-12 col-xl-7">
                        <div class="search_area d-flex">
                            <div class="search-area serach_padding-rgt_20">
                                <input
                                    type="text"
                                    placeholder="Search"
                                    v-model.trim="listConfig.searchKeyword"
                                    @change="getAllOrders(true)"
                                    class="search-form-control"
                                /><button
                                    @click="getAllOrders(true)"
                                    type="submit"
                                    class="search-btn"
                                >
                                    <img
                                        src="/maincss/images/Icon_feather-search.svg"
                                        alt="logo"
                                        class="headerlogo"
                                    />
                                </button>
                            </div>
                            <div class="select_option sec_opt show_all_opt">
                                <label>Status</label>

                                <fieldset>
                                    <v-select
                                        label="label"
                                        :reduce="(status) => status.value"
                                        :options="status_array"
                                        v-model="status_value"
                                        :placeholder="'Show'"
                                        @input="onChangeStatus"
                                    ></v-select>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-content pb-3 px-3 px-sm-0" id="nav-tabContent">
                <div
                    class="tab-pane fade show active"
                    id="nav-contact"
                    role="tabpanel"
                    aria-labelledby="nav-contact-tab"
                >
                    <OrderList
                        :all_orders_list="all_orders_list"
                        :listConfig="listConfig"
                        @updatesorting="sorting($event)"
                        @reOrder="reOrder"
                    />
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <b-pagination
                            v-show="
                                all_orders_list.length > 0 &&
                                item_length > itemsPerPage
                            "
                            v-model="currentPage"
                            :total-rows="item_length"
                            :per-page="itemsPerPage"
                            class="imprint_pagination"
                        ></b-pagination>
                    </div>
                </div>
            </div>
        </div>
        <div class="preloader" v-show="isBusy">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";
import CommonData from "@/common/common.data";
import { mapGetters } from "vuex";
import OrderList from "@/components/OrderListNew";
import IndustryMatchedUsersGroup from "@/components/account/IndustryMatchedUsersGroup.vue";
import { FETCH_INDUSTRY_MATCHED_USER } from "@/store/actions.type";

export default {
    /* eslint-disable */
    name: "Myorder",
    /* eslint-enable */
    components: { OrderList, IndustryMatchedUsersGroup },
    data() {
        return {
            regions: [{ name: "region1", id: 1 }],
            status_array: [{ label: "All", value: "" }],
            status_value: "",
            isBusy: false,
            all_orders_list: [],
            searchedKeyword: "",
            listConfig: {
                searchKeyword: "",
                offset: (this.currentPage - 1) * this.itemsPerPage,
                limit: this.itemsPerPage,
                sortBy: "",
                order: "ASC",
                order_type: "all"
            },
            item_length: 0,
            currentPage: 1,
            itemsPerPage: 10,
            all_order_length: 0,
            status_count: {}
        };
    },
    computed: {
        ...mapGetters(["currentUserClient", "isAuthenticatedClient"]),
        matchedUsers() {
            const code = this.currentUserClient && this.currentUserClient.industry_code;
            if (!code) return [];
            return this.$store.getters["account/getIndustryMatchedUsers"](code);
        },
        pages() {
            if (this.item_length <= this.itemsPerPage) {
                return [1];
            }
            return [
                ...Array(Math.ceil(this.item_length / this.itemsPerPage)).keys()
            ].map((e) => e + 1);
        }
    },
    watch: {
        currentPage(newValue) {
            this.listConfig.offset = (newValue - 1) * this.itemsPerPage;
            this.getAllOrders();
        },
        currentUserClient: {
            immediate: true,
            handler(user) {
                if (user && user.industry_code) {
                    this.$store.dispatch(`account/${FETCH_INDUSTRY_MATCHED_USER}`, {
                        industryCode: user.industry_code
                    });
                }
            }
        }
    },
    mounted() {
        var _this = this;
        _this.listConfig = {
            searchKeyword: "",
            offset: (_this.currentPage - 1) * _this.itemsPerPage,
            limit: _this.itemsPerPage,
            sortBy: "",
            order: "ASC",
            order_type: "all"
        };
        _this.getAllOrders();
        _this.getOrdersCount();
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        /* eslint-enable */
        CommonData.filterOrderStatuses.forEach((status) => {
            _this.status_array.push({ label: status, value: status });
        });
    },
    methods: {
        changeOrders(order_type) {
            this.listConfig.order_type = order_type;
            this.listConfig.sortBy = "";
            this.listConfig.order = "";
            this.listConfig.searchKeyword = "";
            this.listConfig.order_status = "";
            this.getAllOrders(true);
        },
        sorting($event) {
            var _this = this;
            _this.listConfig.sortBy == $event.sortBy;
            _this.listConfig.order == $event.order;
            _this.getAllOrders();
        },
        onChangeRegion(event) {
            this.listConfig.region = event;
            this.getAllOrders(true);
        },
        onChangeStatus(event, status = null) {
            if (status) {
                this.listConfig.order_status = status;
            } else {
                this.listConfig.order_status = event;
            }
            this.getAllOrders(true);
        },
        getAllOrders(pagereset = false) {
            var _this = this;
            if (pagereset) {
                _this.currentPage = 1;
                _this.listConfig.offset = 0;
            }
            _this.isBusy = true;
            new Promise((resolve, reject) => {
                ApiService.post("/all-new-orders", _this.listConfig)
                    .then(({ data }) => {
                        _this.all_orders_list = data.all_orders_list.rows;
                        _this.item_length = data.all_orders_list.count;

                        _this.all_orders_list.forEach((row) => {
                            let artworks = [];
                            row.services = [];
                            _this.searchedKeyword =
                                _this.listConfig.searchKeyword;
                            row.NewOrderItems.forEach((item) => {
                                // Check for new structure (MainNewSubProduct) first
                                let subProduct = item.MainNewSubProduct || item.NewSubProduct;
                                
                                if (
                                    item.NewOrderItemDecoration &&
                                    subProduct
                                ) {
                                    // Get parent_product_id - MainNewSubProduct has parent_product_id directly
                                    let parent_product_id = subProduct.parent_product_id || 
                                        (subProduct.MainNewProducts ? subProduct.MainNewProducts.id : null) ||
                                        (subProduct.NewProduct ? subProduct.NewProduct.id : null);
                                    
                                    // Get color_id - MainNewSubProduct has color_id directly or via Color relation
                                    let color_id = subProduct.color_id || 
                                        (subProduct.Color ? subProduct.Color.id : null);
                                    
                                    let artwork = artworks.find(
                                        (item_data) =>
                                            item_data.parent_id == parent_product_id &&
                                            item_data.color_id == color_id &&
                                            item_data.gender_size_id ==
                                                item.gender_size_id &&
                                            item_data.unique_item_id ==
                                                item.unique_item_id
                                    );

                                    let image = "";
                                    if (item.NewOrderItemDecoration.art_work) {
                                        image =
                                            item.NewOrderItemDecoration
                                                .art_work;
                                    }

                                    // Storing if have design images like front, back etc.,
                                    let design_images = [];
                                    if (item.design_image) {
                                        try {
                                            design_images = item.design_image
                                                ? JSON.parse(item.design_image)
                                                : [];
                                            let front_design = design_images.find(
                                                (image) => image.label == "front"
                                            );
                                            if (front_design) {
                                                image = front_design.url;
                                            } else if (design_images.length > 0) {
                                                image = design_images[0].url;
                                            }
                                        } catch (e) {
                                            console.error('Error parsing design_image:', e);
                                        }
                                    }

                                    if (image && !artwork) {
                                        artworks.push({
                                            parent_id: parent_product_id,
                                            color_id: color_id,
                                            gender_size_id: item.gender_size_id,
                                            artwork: image,
                                            unique_item_id: item.unique_item_id
                                        });
                                    }

                                    if (
                                        item.NewOrderItemDecoration
                                            .decoration_type == 1 &&
                                        !row.services.includes("SCP")
                                    ) {
                                        row.services.push("SCP");
                                    } else if (
                                        item.NewOrderItemDecoration
                                            .decoration_type == 2 &&
                                        !row.services.includes("EMB")
                                    ) {
                                        row.services.push("EMB");
                                    }
                                }
                            });
                            row.total_due = 0;

                            if (row.additional_payment_status != "PAID") {
                                let modified_fees = row.modified_fees
                                    ? JSON.parse(row.modified_fees)
                                    : null;

                                let additional_fees = {};
                                if (modified_fees) {
                                    if (modified_fees.new_color_fee) {
                                        additional_fees.color_fees = parseFloat(
                                            modified_fees.new_color_fee
                                        );
                                        row.total_due +=
                                            additional_fees.color_fees;
                                    }
                                    if (modified_fees.new_design_fee) {
                                        additional_fees.item_fees = parseFloat(
                                            modified_fees.new_design_fee
                                        );
                                        row.total_due +=
                                            additional_fees.item_fees;
                                    }
                                    if (modified_fees.order_fees) {
                                        additional_fees.order_fees = parseFloat(
                                            modified_fees.order_fees
                                        );
                                        row.total_due +=
                                            additional_fees.order_fees;
                                    }
                                }
                                row.modified_fees = additional_fees;
                            }
                            row["artworks"] = artworks;
                            
                            // Calculate total artwork count - har unique item ke front, back, left, right sab sides ka count
                            // Count directly from NewOrderItems to ensure we don't miss any design_images
                            let totalArtworkCount = 0;
                            let countedItems = new Set(); // Track unique items we've already counted
                            
                            row.NewOrderItems.forEach((item) => {
                                // Check for new structure (MainNewSubProduct) first
                                let subProduct = item.MainNewSubProduct || item.NewSubProduct;
                                
                                if (
                                    item.NewOrderItemDecoration &&
                                    subProduct
                                ) {
                                    // Get parent_product_id - MainNewSubProduct has parent_product_id directly
                                    let parent_product_id = subProduct.parent_product_id || 
                                        (subProduct.MainNewProducts ? subProduct.MainNewProducts.id : null) ||
                                        (subProduct.NewProduct ? subProduct.NewProduct.id : null);
                                    
                                    // Get color_id - MainNewSubProduct has color_id directly or via Color relation
                                    let color_id = subProduct.color_id || 
                                        (subProduct.Color ? subProduct.Color.id : null);
                                    
                                    // Create unique key for this item (same logic as artworks array)
                                    let uniqueKey = `${parent_product_id}_${color_id}_${item.gender_size_id}_${item.unique_item_id}`;
                                    
                                    // Only count once per unique item
                                    if (!countedItems.has(uniqueKey)) {
                                        countedItems.add(uniqueKey);
                                        
                                        if (item.design_image) {
                                            try {
                                                let design_images = JSON.parse(item.design_image);
                                                if (Array.isArray(design_images)) {
                                                    // Count all artworks: for each design_image object,
                                                    // if canvas_images array exists, use its length; otherwise count 1.
                                                    design_images.forEach((designImg) => {
                                                        if (designImg) {
                                                            if (designImg.canvas_images && Array.isArray(designImg.canvas_images) && designImg.canvas_images.length > 0) {
                                                                totalArtworkCount += designImg.canvas_images.length;
                                                            } 
                                                            else if (designImg.design_image || designImg.url || designImg.design_image_path_png) {
                                                                totalArtworkCount += 1;
                                                            }
                                                        }
                                                    });
                                                }
                                            } catch (e) {
                                                // If parsing fails, check if it's already an array
                                                if (Array.isArray(item.design_image)) {
                                                    item.design_image.forEach((designImg) => {
                                                        if (designImg) {
                                                            if (designImg.canvas_images && Array.isArray(designImg.canvas_images) && designImg.canvas_images.length > 0) {
                                                                totalArtworkCount += designImg.canvas_images.length;
                                                            } else if (designImg.design_image || designImg.url || designImg.design_image_path_png) {
                                                                totalArtworkCount += 1;
                                                            }
                                                        }
                                                    });
                                                }
                                            }
                                        } else if (item.NewOrderItemDecoration && item.NewOrderItemDecoration.art_work) {
                                            // If no design_image but has art_work, count as 1
                                            totalArtworkCount += 1;
                                        }
                                    }
                                }
                            });
                            row["total_artwork_count"] = totalArtworkCount;
                        });
                        _this.isBusy = false;
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        _this.isBusy = false;
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                        reject(response);
                    });
            });
        },
        getOrdersCount() {
            return new Promise((resolve, reject) => {
                ApiService.query("/orders-count")
                    .then(({ data }) => {
                        this.all_order_length = data.total_orders;
                        this.status_count = data.status_count;
                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },
        prepareCartItems(order) {
            let order_items = [];
            order.NewOrderItems.forEach((item) => {
                if (item.NewSubProduct) {
                    let index = order_items.findIndex(
                        (item_data) =>
                            item_data.item_id ==
                                item.NewSubProduct.parent_product_id &&
                            item_data.color_id == item.NewSubProduct.color_id &&
                            item_data.gender_size_id == item.gender_size_id
                    );
                    let subItem = {
                        sub_product_id: item.sub_product_id,
                        user_id: this.currentUserClient.id,
                        case_price: item.base_price,
                        markup_price: item.markup_price,
                        markup_percentage: item.markup_percentage,
                        ink_price: item.ink_price,
                        single_location_price: item.single_location_price,
                        quantity: item.quantity,
                        discount: item.discount,
                        unit_price: item.price,
                        total_price: item.total_price
                    };
                    if (index >= 0 && order_items[index]) {
                        order_items[index]["items"].push(subItem);
                        order_items[index]["total_quantity"] += item.quantity;
                        order_items[index]["total_price"] += parseFloat(
                            item.total_price
                        );
                        order_items[index]["total_discount"] += parseFloat(
                            item.discount
                        );
                        order_items[index]["subtotal_price"] += parseFloat(
                            item.total_price
                        );
                    } else {
                        let imprint_locations_price = 0;
                        let imprint_locations = item["imprint_locations"]
                            ? JSON.parse(item["imprint_locations"])
                            : [];
                        if (imprint_locations) {
                            imprint_locations.forEach((location) => {
                                if (location.is_selected) {
                                    location.colors.forEach((color) => {
                                        if (color.decor_upcharge) {
                                            imprint_locations_price +=
                                                parseFloat(
                                                    color.decor_upcharge
                                                        .color_cost
                                                ) + parseFloat(color.cost_cost);
                                        } else {
                                            imprint_locations_price +=
                                                parseFloat(color.cost_cost);
                                        }
                                    });
                                }
                            });
                        }

                        let order_item = {
                            user_id: this.currentUserClient.id,
                            item_id: item.NewSubProduct.parent_product_id,
                            gender_size_id: item.gender_size_id,
                            color_id: item.NewSubProduct.color_id,
                            decoration_type:
                                item.NewOrderItemDecoration.decoration_type,
                            price_decoration_bulk: item.NewOrderItemDecoration
                                .decorations
                                ? JSON.parse(
                                      item.NewOrderItemDecoration.decorations
                                  )
                                : null,
                            more_decorations: item.NewOrderItemDecoration
                                .more_decorations
                                ? JSON.parse(
                                      item.NewOrderItemDecoration
                                          .more_decorations
                                  )
                                : [],
                            artwork: item.NewOrderItemDecoration.art_work,
                            items: [subItem],
                            imprint_locations: imprint_locations,
                            total_design_fee: item.design_fee,
                            total_quantity: item.quantity,
                            setup_fee: item.setup_fee,
                            imprint_locations_price: imprint_locations_price,
                            total_dark_category_fee:
                                item.total_dark_category_fee,
                            total_light_category_fee:
                                item.total_light_category_fee,
                            total_discount: parseFloat(item.discount),
                            total_price:
                                parseFloat(item.total_price) +
                                parseFloat(item.design_fee) +
                                parseFloat(item.setup_fee) +
                                parseFloat(imprint_locations_price),
                            subtotal_price: parseFloat(item.total_price),
                            design_image: item.design_image
                                ? JSON.parse(item.design_image)
                                : [],
                            product_image: item.product_image,
                            design_area_inches: item.design_area_inches,
                            name_and_number_json: item.name_and_number_json
                                ? JSON.parse(item.name_and_number_json)
                                : [],
                            font_color_sizes_name: item.font_color_sizes_name
                                ? JSON.parse(item.font_color_sizes_name)
                                : [],
                            font_color_sizes_number:
                                item.font_color_sizes_number
                                    ? JSON.parse(item.font_color_sizes_number)
                                    : [],
                            t_shirt_24_hour: 0
                        };

                        let remaining_sizes = item.remaining_sizes
                            ? JSON.parse(item.remaining_sizes)
                            : [];

                        if (remaining_sizes) {
                            remaining_sizes.forEach((s) => {
                                order_item["items"].push({
                                    sub_product_id: s.sub_product_id,
                                    user_id: this.currentUserClient.id,
                                    case_price: s.case_price,
                                    markup_price: subItem.markup_price,
                                    markup_percentage:
                                        subItem.markup_percentage,
                                    ink_price: subItem.ink_price,
                                    single_location_price:
                                        subItem.single_location_price,
                                    quantity: 0,
                                    discount: subItem.discount,
                                    unit_price: s.unit_price,
                                    total_price: 0
                                });
                            });
                        }

                        order_items.push(order_item);
                    }
                }
            });

            order_items.forEach((order_item) => {
                let sub_product_ids = order_item.items.map(
                    (item) => item.sub_product_id
                );
                sub_product_ids = sub_product_ids.sort();
                let sorted_items = [];
                sub_product_ids.forEach((id) => {
                    let existed_item = order_item.items.find(
                        (ele) => ele.sub_product_id == id
                    );
                    if (existed_item) {
                        sorted_items.push(existed_item);
                    }
                });
                order_item.items = sorted_items;
            });
            return order_items;
        },
        reOrder(order) {
            this.isBusy = true;
            return new Promise((resolve, reject) => {
                const cartItems = this.prepareCartItems(order);
                ApiService.post("/add-to-cart", cartItems)
                    .then(({ data }) => {
                        this.isBusy = false;
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }

                        this.$root.$emit("update-cart", { type: "success" });
                        this.$router.push({ name: "cart" });

                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        this.isBusy = false;
                        reject(err);
                    });
            });
        }
    }
};
</script>
